import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { renderTier } from './Components/Dashboard/utils/renderTier';
import reportWebVitals from './reportWebVitals';
// Het font gaat mee in de build in plaats van dat we hopen dat het op het
// apparaat staat. Zonder dit valt de Raspberry Pi terug op zijn eigen
// systeemfont (DejaVu Sans) en staat het dashboard er daar anders op dan
// hier. Meegebouwd betekent ook: geen internet nodig om het te laden.
import '@fontsource-variable/inter';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// De kwaliteitstrap (high/mid/low) komt als data-fx-tier op <html> te
// staan, en de CSS leest hem daar uit. Dat moet vóór het eerste beeld: doen
// we het later, dan staat het zware beeld er eerst en schakelt het scherm
// zichtbaar om. Zie Dashboard/utils/renderTier.js.
renderTier();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
